type ViewportSlot = 'above' | 'in' | 'below'

export function viewportSlot(
  rect: { top: number; bottom: number },
  viewportHeight: number,
): ViewportSlot {
  if (rect.bottom <= 0) {
    return 'above'
  }
  if (rect.top >= viewportHeight) {
    return 'below'
  }
  return 'in'
}

/**
 * Where "next required field" goes, given the remaining fields in page order:
 * the first one on screen or below it, else back to the first, one the signer
 * scrolled past. Null when nothing is left.
 */
export function nextRequiredId(
  items: readonly { id: string; slot: ViewportSlot }[],
): string | null {
  return (items.find((item) => item.slot !== 'above') ?? items[0])?.id ?? null
}
